import { useEffect, useState } from "react";
import { BOOKING_CHECK_FLIGHT, ITRAVEL_KEY_API, MAIN_LAMBDA } from "../utils/constants";
import { GET } from "../utils/api";
import {
  definitionsWithCombinationsBaggage,
  formatBaggageDefinitions,
  getItemFromLocalStorage,
} from "../common/methods";
import { PARTNERID, SIGNATURE } from "../utils/enums";
import { useStoreFly } from "../store";
 
const baggageForBooking = (combinations, definitions) => { 
  // Log incoming data

  // Return default structure if data is missing
  if (!combinations || !definitions) {
    console.warn('Missing baggage data:', { combinations, definitions });
    return {
      handBags: [],
      holdBags: [],
      handBagsWithDimensions: [],
      holdBagsWithDimensions: [],
      handBagsToPay: [],
      holdBagsToPay: [],
    };
  }

  try {
    const definitionHandBag = definitions?.baggageWeight;
    const definitionHoldBag = definitions?.baggageWeight;
    const combinationHandBag = combinations?.baggageWeight;
    const combinationHoldBag = combinations?.baggageWeight;


  const formattedDefinitions = formatBaggageDefinitions(
    definitionHandBag,
    definitionHoldBag
  );
  const formattedCombinations = formatBaggageDefinitions(
    combinationHandBag,
    combinationHoldBag
  );

  const { handBags, holdBags } = definitionsWithCombinationsBaggage(
    formattedDefinitions?.formattedHandBag,
    formattedDefinitions?.formattedHoldBag,
    formattedCombinations?.formattedHandBag,
    formattedCombinations?.formattedHoldBag,
    0
  );

    const handBagsToPay = handBags?.filter((handB) => !handB?.is_free) || [];
    const holdBagsToPay = holdBags?.filter((holdB) => !holdB?.is_free) || [];
  const handBagsWithDimensions = handBags?.filter(
    (handB) => handB?.dimensions && handB.is_free
    ) || [];
  const holdBagsWithDimensions = holdBags?.filter(
    (holdB) => holdB?.dimensions && holdB.is_free
    ) || [];

  return {
    handBags,
    holdBags,
    handBagsWithDimensions,
    holdBagsWithDimensions,
    handBagsToPay,
    holdBagsToPay,
  };
  } catch (error) {
    console.error('Error processing baggage data:', error);
    return {
      handBags: [],
      holdBags: [],
      handBagsWithDimensions: [],
      holdBagsWithDimensions: [],
      handBagsToPay: [],
      holdBagsToPay: [],
    };
  }
};

// Funksionet ndihmëse
function joinSegments(data) {  
  if (!data) {
    return [];
  }

  let segments = data?.segments;
  let flights = data?.flights;
  let solutions = data?.solution ? [data?.solution] : [];

  if (!segments || !flights || !solutions.length) {
    return [];
  }

  solutions.forEach((el) => {
    if (!el) return;

    let adultPrice = el.adtFare + el.adtTax + el.tktFee;
    let childPrice = el.chdFare + el.chdTax + el.tktFee;
    let infantPrice = (el.infFare ? el.infFare : 0) + (el.infTax ? el.infTax : 0) + el.tktFee;
    let totalPrice = (adultPrice * el.adults) + (childPrice * el.children) + (infantPrice * (el.infant ? el.infant : 0)) + el.platformServiceFee + el.merchantFee;
    let journKeys = Object.keys(el.journeys || {});
    
    el.totalPrice = totalPrice;
    journKeys.forEach((journ) => { 
      if (!el.journeys[journ]) return;

      let tempJournObj = flights.find((fl) => fl.flightId === el.journeys[journ][0]);
      if (!tempJournObj) return;

      el.journeys[journ] = tempJournObj;
      let tempSegments = [];
      
      if (!el.journeys[journ].segmentIds) return;

      el.journeys[journ].segmentIds.forEach((journSegment) => {   
        if (!journSegment) return;

        let isReturn = journ === 'journey_1';
        let segment = segments.find((jourSegmentId) => jourSegmentId.segmentId === journSegment);
        if (!segment) return;

        tempSegments.push({ ...segment, isReturn });
      });
      
      el.journeys[journ].segmentIds = tempSegments;
    });
    
    el.totalJourney = (el.journeys.journey_0?.journeyTime || 0) + (el.journeys.journey_1?.journeyTime || 0);
  });  

  return solutions;
}

function mergeAncillaryWithSegments(ancillary, data) {  
  
  if (!data || !ancillary || !Array.isArray(ancillary)) {
    return;
  }

  // Check for journeys in the correct location (data.solution.journeys)
  const journeys = data.solution?.journeys;
  if (!journeys) {
    return;
  }


  // Initialize journey structures at the top level for BaggageSection
  data.journey_0 = { segmengtIds: [] };
  data.journey_1 = { segmengtIds: [] };

  // Process each ancillary item to match with corresponding segments
  ancillary.forEach((ancillaryItem, index) => {
    
    if (!ancillaryItem?.ancillary?.journeys || !ancillaryItem?.ancillary?.ancillaries?.baggage) {
      return;
    }

    const ancillaryJourney = ancillaryItem.ancillary.journeys[0]; // Each ancillary item has one journey
    const baggageData = ancillaryItem.ancillary.ancillaries.baggage;
    

    // Find matching segment in precise data
    const matchingSegment = data.segments?.find(segment => 
      segment.flightNum === ancillaryJourney.flightNum &&
      segment.departure === ancillaryJourney.departure &&
      segment.arrival === ancillaryJourney.arrival
    );

    if (matchingSegment) {
      
      // Create segment with baggage info
      const segmentWithBaggage = {
        ...matchingSegment,
        baggageInfo: {
          baggage: baggageData.map(bag => ({
            ...bag,
            segmentId: matchingSegment.segmentId
          }))
        }
      };
      
      // Determine which journey this segment belongs to by checking flight IDs
      let journeyKey = null;
      Object.keys(journeys).forEach(jKey => {
        const flightIds = journeys[jKey];
        const matchingFlight = data.flights?.find(f => 
          flightIds.includes(f.flightId) && 
          f.segmentIds.includes(matchingSegment.segmentId)
        );
        if (matchingFlight) {
          journeyKey = jKey;
        }
      });

      if (journeyKey) {
        
        // Add segment with baggage info to the appropriate journey
        data[journeyKey].segmengtIds.push(segmentWithBaggage);
        
      } else {
      }
    } else {
    }
  });

}

// Transform complex flight journeys back to PKFare format
const transformJourneysForPKFare = (journeys) => {
  
  if (!journeys) {
    return {};
  }
  
  const transformed = {};
  
  Object.keys(journeys).forEach(journeyKey => {
    const journey = journeys[journeyKey];
    
    // If journey is already in simple array format, keep it
    if (Array.isArray(journey)) {
      transformed[journeyKey] = journey;
      return;
    }
    
    // If journey is a complex object, try to extract segment data
    if (journey && typeof journey === 'object') {
      let segments = [];
      
      // Case 1: Journey has segmentIds array
      if (journey.segmentIds && Array.isArray(journey.segmentIds)) {
        segments = journey.segmentIds.map(segment => ({
          airline: segment.airline,
          flightNum: segment.flightNum,
          arrival: segment.arrival,
          arrivalDate: segment.strArrivalDate || segment.arrivalDate,
          arrivalTime: segment.strArrivalTime || segment.arrivalTime,
          departure: segment.departure,
          departureDate: segment.strDepartureDate || segment.departureDate,
          departureTime: segment.strDepartureTime || segment.departureTime,
          bookingCode: segment.bookingCode
        }));
      }
      // Case 2: Journey has segments array
      else if (journey.segments && Array.isArray(journey.segments)) {
        segments = journey.segments.map(segment => ({
          airline: segment.airline,
          flightNum: segment.flightNum,
          arrival: segment.arrival,
          arrivalDate: segment.strArrivalDate || segment.arrivalDate,
          arrivalTime: segment.strArrivalTime || segment.arrivalTime,
          departure: segment.departure,
          departureDate: segment.strDepartureDate || segment.departureDate,
          departureTime: segment.strDepartureTime || segment.departureTime,
          bookingCode: segment.bookingCode
        }));
      }
      // Case 3: Journey is itself a segment object
      else if (journey.airline && journey.flightNum) {
        segments = [{
          airline: journey.airline,
          flightNum: journey.flightNum,
          arrival: journey.arrival,
          arrivalDate: journey.strArrivalDate || journey.arrivalDate,
          arrivalTime: journey.strArrivalTime || journey.arrivalTime,
          departure: journey.departure,
          departureDate: journey.strDepartureDate || journey.departureDate,
          departureTime: journey.strDepartureTime || journey.departureTime,
          bookingCode: journey.bookingCode
        }];
      }
      // Case 4: Try to find nested segment data
      else {
        // Look for any property that might contain segment data
        for (const [key, value] of Object.entries(journey)) {
          if (Array.isArray(value) && value.length > 0 && value[0].airline) {
            segments = value.map(segment => ({
              airline: segment.airline,
              flightNum: segment.flightNum,
              arrival: segment.arrival,
              arrivalDate: segment.strArrivalDate || segment.arrivalDate,
              arrivalTime: segment.strArrivalTime || segment.arrivalTime,
              departure: segment.departure,
              departureDate: segment.strDepartureDate || segment.departureDate,
              departureTime: segment.strDepartureTime || segment.departureTime,
              bookingCode: segment.bookingCode
            }));
            break;
          }
        }
      }
      
      if (segments.length > 0) {
        transformed[journeyKey] = segments;
      } else {
      }
    }
  });
  
  return transformed;
};

export const useCheckFlight = (
  flight,
  currency,
  adult,
  children,
  babies,
  bnum
) => { 
  const [price, setPrice] = useState(0);
  const [bookingFlightDetails, setBookingFlightDetails] = useState();
  const [handBagDimensions, setHandBagDimensions] = useState([]);
  const [holdBagDimensions, setHoldBagDimensions] = useState([]);
  const [holdBagsToPay, setHoldBagsToPay] = useState([]);
  const [baggageInfo, setBaggageInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFlightDetails = async () => {
      try {
        setLoading(true);
        setError(null);

        // 🔍 DEBUG: Log complete flight object structure

        // Transform journeys to PKFare format
        const transformedJourneys = transformJourneysForPKFare(flight.journeys);

        // 1. Make precise-pricing call to PKFare API
        const precisePricingPayload = {
          authentication: {
            partnerId: PARTNERID,
            sign: SIGNATURE
          },
          pricing: {
            journeys: transformedJourneys,
            adults: adult,
            children: children,
            infants: babies,
            solutionId: flight.solutionId
          }
        };

        
        const precisePricingResponse = await fetch(
          `${MAIN_LAMBDA}/precise-pricing`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(precisePricingPayload)
          }
        ).then(res => res.json());


        if (precisePricingResponse.errorCode !== "0") {
          throw new Error(precisePricingResponse?.errorMsg || 'Failed to get precise pricing');
        }

        // Store precise pricing data
        const preciseData = precisePricingResponse.data;
        setBookingFlightDetails(preciseData);
        setPrice(preciseData?.totalPrice || 0);

        // Save to localStorage for later use
        localStorage.setItem('preciseSearchData', JSON.stringify(preciseData));

        // 2. Make ancillary-pricing call to get baggage information
        const ancillaryPricingPayload = {
          authentication: {
            partnerId: PARTNERID,
            sign: SIGNATURE
          },
          pricing: {
            adults: adult,
            children: children,
            ancillary: [1], // Baggage type
            journeys: transformedJourneys,
            solutionId: flight.solutionId
          }
        };


        const ancillaryResponse = await fetch(
          `${MAIN_LAMBDA}/ancillary-pricing`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(ancillaryPricingPayload)
          }
        ).then(res => res.json());


        if (ancillaryResponse.errorCode === "0" && ancillaryResponse.data) {
          // Process baggage information from ancillary response
          const ancillaryData = ancillaryResponse.data;
          
          // Merge ancillary data with flight segments for easier access
          const mergedFlightData = { ...preciseData };
          mergeAncillaryWithSegments(ancillaryData, mergedFlightData);
          
          // Update the baggageInfo state with the merged data 
          setBaggageInfo(mergedFlightData);
          
          // Process baggage from each ancillary item
          ancillaryData.forEach(item => {
            if (item.ancillary && item.ancillary.ancillaries && item.ancillary.ancillaries.baggage) {
              const baggageItems = item.ancillary.ancillaries.baggage;
              
              // Separate baggage by type
              const handBags = baggageItems.filter(bag => 
                bag.payBaggageType === 0 || bag.baggageWeight.includes('Cabin') || bag.baggageWeight.includes('Hand')
              );
              
              const holdBags = baggageItems.filter(bag => 
                bag.payBaggageType === 1 || (!bag.baggageWeight.includes('Cabin') && !bag.baggageWeight.includes('Hand'))
              );

              // Set dimensions and payable bags
              setHandBagDimensions(handBags.map(bag => ({
                ...bag,
                dimensions: `${bag.baggageWeight}`,
                weight: bag.baggageWeight,
                price: bag.baggagePrice,
                currency: bag.baggageCurrency,
                is_free: bag.baggagePrice === 0
              })));

              setHoldBagDimensions(holdBags.map(bag => ({
                ...bag,
                dimensions: `${bag.baggageWeight}`,
                weight: bag.baggageWeight,
                price: bag.baggagePrice,
                currency: bag.baggageCurrency,
                is_free: bag.baggagePrice === 0
              })));

              setHoldBagsToPay(holdBags.filter(bag => bag.baggagePrice > 0));
            }
          });
          
          // Save ancillary data for later use
          localStorage.setItem('ancillaryData', JSON.stringify(ancillaryData));
          
        } else {
          // Pass error information to BaggageSection instead of setting to null
          setBaggageInfo({
            errorCode: ancillaryResponse?.errorCode,
            errorMsg: ancillaryResponse?.errorMsg,
            hasError: true
          });
          // Set empty baggage data
          setHandBagDimensions([]);
          setHoldBagDimensions([]);
          setHoldBagsToPay([]);
        }

      } catch (err) {
        console.error('Error fetching flight details:', err);
        setError(err.message);
        
        // Set default values on error
        setHandBagDimensions([]);
        setHoldBagDimensions([]);
        setHoldBagsToPay([]);
        setBaggageInfo(null);
        setBookingFlightDetails(null);
        setPrice(0);
      } finally {
        setLoading(false);
      }
    };

    if (flight && currency) {
      fetchFlightDetails();
    }
  }, [flight, currency, adult, children, babies, bnum]);

  return {
    price,
    bookingFlightDetails,
    handBagDimensions,
    holdBagDimensions,
    holdBagsToPay,
    setPrice,
    baggageInfo,
    loading,
    error
  };
};
